import { useState } from 'react';
import { ModuleDataHandler } from '../helpers/handleReportCalc';
import TBodyRow from './TBodyRow';
import { useQuery } from '../../../../hooks/UseQuery';
interface IProps {
  moduleData: any;
  numberOfDay: any;
  isView: boolean;
}

const TBody = ({ moduleData, isView, numberOfDay }: IProps) => {
  const department_name = useQuery('department_name');
  const [render, setRender] = useState<boolean>(false);
  return (
    <tbody>
      {moduleData?.list?.length > 0 &&
        moduleData?.list?.map((item: any, index: number) => (
          <TBodyRow
            {...{
              moduleData,
              item,
              index,
              isView,
              numberOfDay,
              setRender,
            }}
          />
        ))}
      {moduleData?.list?.length > 0 && (
        <tr>
          <td
            colSpan={5}
          >{`DEPARTMENT ${department_name?.toUpperCase()} TOTALS`}</td>
          <td>{moduleData.total_tot}</td>
          <td>{moduleData.total_mobile}</td>
          <td>{moduleData.total_spl_allowance}</td>
          <td>{moduleData.total_w_day}</td>
          <td>{moduleData.total_p_day}</td>
          <td>{moduleData.total_l_day}</td>
          <td>{moduleData.total_total_1}</td>
          <td>{moduleData.total_amount}</td>

          <td>{moduleData.total_ot_hr_s}</td>
          <td>{moduleData.total_ot_hr}</td>
          <td>{moduleData.total_ot_amount}</td>
          <td>{moduleData.total_total_2}</td>

          <td>{moduleData.total_pf}</td>
          <td>{moduleData.total_esic}</td>
          <td>{moduleData.total_labour}</td>
          <td>{moduleData.total_total_3}</td>

          <td>{moduleData.total_tea}</td>
          <td>{moduleData.total_adv}</td>
          <td>{moduleData.total_payable}</td>
          <td>{moduleData.total_cheque_payment}</td>
          <td>{moduleData.total_cash_payable}</td>
        </tr>
      )}
    </tbody>
  );
};

export default TBody;
